import React, { useState, useEffect } from "react";
import DepositWithdrawSuccessMsg from "../common/DepositWithdrawSuccessMsg";
import { useDispatch, useSelector } from "react-redux";
import {
  handleWithdrawAPI,
  setWithdrawErrMsg,
  setWithdrawError,
  setWithdrawSuccess,
} from "./cl_withdraw";
import { fetchAccountDetails } from "../accountDetails/cl_AccountDetailsSlice";
import { getFromLocalStorage } from "../../services/helper/cl_Helper";
import { paymentConfig } from "../signIn/cl_SignInSlice";
import icons from "../../assets/images/sprite-other-icons.svg";
import { useNavigate } from "react-router-dom";

function Withdraw() {
  const [withdrawAmount, setWithdrawAmount] = useState("20");
  const dispatch = useDispatch();
   const {
    userDetails,
  } = useSelector((state) => state?.signIn);
  const { accountDetailsData } = useSelector((state) => state?.accountDetails);
  const countryCode = accountDetailsData?.userOtherInfo?.country;
  const {
    withdrawResponse,
    loader,
    withdrawError,
    withdrawSuccess,
    withdrawErrMsg,
  } = useSelector((state) => state?.withdraw);
  const { balanceDetails } = useSelector((state) => state?.signIn);
  const maxLimit = 70000;
  const re = /^[0-9]+$/;
  function avoidCharacter(e) {
    if (!re.test(e.key)) {
      e.persist();
      e.preventDefault();
    }
  }
  const token = getFromLocalStorage("gk");
  const userEmail = accountDetailsData?.userOtherInfo?.email;
  const userNumber =
    accountDetailsData?.userOtherInfo?.countryCode +
    "" +
    accountDetailsData?.userOtherInfo?.phone;
  const userId = accountDetailsData?.userId;
  const phoneNumber = accountDetailsData?.userOtherInfo?.phone
  useEffect(() => {
    dispatch(paymentConfig());
  }, []);
  const handleInput = (e) => {
    dispatch(setWithdrawErrMsg(""));
    const inputValue = e.target.value;
    const newValue = inputValue.replace(/[^0-9]/g, "");
    setWithdrawAmount(newValue);
  };
  useEffect(() => {
    dispatch(fetchAccountDetails(token));
    dispatch(setWithdrawError(false));
    dispatch(setWithdrawSuccess(false));
    dispatch(setWithdrawErrMsg(""));
    //dispatch(getRealBalance())
  }, []);
  const handleValidation = (e) => {
    const allowedKeys = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
    const allowedKeyPadKeys = [96, 97, 98, 99, 100, 101, 102, 103, 104, 105];
    if (
      allowedKeys.indexOf(e.keyCode) === -1 &&
      allowedKeyPadKeys.indexOf(e.keyCode) === -1 &&
      e.keyCode !== 8
    ) {
      e.preventDefault();
    }
  };
  const navigate = useNavigate();

  
  const handleWithdraw = () => {
    if (loader) return;
      const userType = userDetails?.userType

    if (balanceDetails?.real_balance?.result?.withdrawls < 20) {
      dispatch(
        setWithdrawErrMsg(
          "Insufficient funds. Minimum withdrawable amount is KES 20"
        )
      );
    } else if (withdrawAmount >= 20 && withdrawAmount <= maxLimit) {
      if (balanceDetails?.real_balance?.result?.withdrawls < withdrawAmount) {
        dispatch(
          setWithdrawErrMsg(
            `Please enter value between KES 20 to KES ${balanceDetails?.real_balance?.result?.withdrawls}`
          )
        );
      } else {
        dispatch(
          handleWithdrawAPI(
            withdrawAmount,
            userEmail,
            userNumber,
            userId,
            countryCode,
            userType,
            phoneNumber
          )
        );
      }
    } else {
      dispatch(
        setWithdrawErrMsg(`Please enter value between KES 20 to ${maxLimit}`)
      );
    }
  };
  const goBack = () => {
    navigate("/");
  };
  return (
    <React.Fragment>
      <div className="SB-page-content">
        <div className="SB-myAccountSection-container SB-deposit">
          <div className="SB-pageHeader">
            <div className="SB-pageBackButton">
              <div className="SB-iconSVG" onClick={goBack}>
                <svg xmlns="http://www.w3.org/2000/svg">
                  <use xlinkHref={`${icons}#icon-back`} />
                </svg>
              </div>
            </div>
            <div className="SB-pageHeader-title">Withdraw</div>
          </div>

          {!withdrawSuccess ? (
            <div id="SB-deposit-chooseMethod">
              <div className="SB-content">
                <div className="SB-paymentMethodsList d-none">
                  <ul>
                    <li>
                      <div className="SB-paymentMethod selected">
                        <div className="SB-paymentMethod-logo">
                          <img src="images/payments/pix.svg" alt="Pix" />
                        </div>
                        <div className="SB-payment-title">Pix</div>
                      </div>
                    </li>
                    <li>
                      <div className="SB-paymentMethod">
                        <div className="SB-paymentMethod-logo">
                          <img src="images/payments/finrax.svg" alt="Finrax" />
                        </div>
                        <div className="SB-payment-title">Finrax</div>
                      </div>
                    </li>
                    <li>
                      <div className="SB-paymentMethod">
                        <div className="SB-paymentMethod-logo">
                          <img src="images/payments/anSpacePay.webp" alt="An SpacePay" />
                        </div>
                        <div className="SB-payment-title">An Space Pay</div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="SB-form-group">
                  <div className="SB-form-label">
                    Enter Amount{" "}
                    <span className="SB-amountMinMax">
                      (Min KES 20 - Max KES 70,000)
                    </span>
                  </div>

                  <div className="SB-form-control-group SB-mobileNumberField">
                    <div className="SB-form-addon SB-addon-left">
                      <div className="SB-regionCode">KES</div>
                    </div>
                    <div className="SB-form-control">
                      <input
                        type={"tel"}
                        placeholder="Enter Amount Here"
                        className="SB-inputAddon"
                        value={withdrawAmount}
                        onChange={handleInput}
                        maxLength={10}
                        onKeyDown={(e) => handleValidation(e)}
                        onKeyPress={(e) => avoidCharacter(e)}
                      />
                    </div>
                  </div>
                </div>
                <div className="SB-space10"></div>
                <button
                  className="btn SB-btnSecondary SB-btnLarge active"
                  id="SB-btn-Deposit"
                  onClick={handleWithdraw}
                >
                  <div className="SB-btnTxt">{loader ? "" : "Withdraw"}</div>
                  <div
                    className={`SB-loader-container ${loader ? "" : "d-none"}`}
                  >
                    <div className="SB-loader"></div>
                  </div>
                </button>
                <div className="SB-contentBlock SB-withdrawBalance-block">
                  <div className="SB-leftContent">
                    <div className="SB-balanceLabel">Withdrawable Balance</div>
                  </div>
                  <div className="SB-rightContent">
                    <div className="SB-userBalance">
                      {" "}
                      {balanceDetails?.real_balance?.result?.withdrawls.toLocaleString()}{" "}
                    </div>
                  </div>
                </div>
                {withdrawErrMsg ? (
                  <div
                    className="SB-msgBox SB-error"
                    id="userProfileDetailsSaved"
                  >
                    <div
                      className="SB-msgBox-container"
                      id="userProfileDetailsError"
                    >
                      {withdrawErrMsg ? withdrawErrMsg : withdrawResponse}
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          ) : (
            !withdrawError && (
              <div id="SB-deposit-success" style={{ display: "block" }}>
                <DepositWithdrawSuccessMsg message={"withdraw"} />
              </div>
            )
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default Withdraw;
